import React from "react";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { trpc, trpcClientConfig } from "~/lib/trpc";
import { I18nProvider } from "~/lib/i18n";
import { AppShell } from "~/components/AppShell";
import Landing from "~/routes/Landing";
import Home from "~/routes/Home";
import ScanNew from "~/routes/ScanNew";
import ScanDashboard from "~/routes/ScanDashboard";
import ListingDetail from "~/routes/ListingDetail";
import Account from "~/routes/Account";
import Marche from "~/routes/Marche";
import MarcheModel from "~/routes/MarcheModel";
import Login from "~/routes/Login";
import NotFound from "~/routes/NotFound";

export default function App(): React.JSX.Element {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );
  const [client] = useState(() => trpc.createClient(trpcClientConfig));

  return (
    <trpc.Provider client={client} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
        <BrowserRouter>
          <AppShell>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/scans" element={<Home />} />
              <Route path="/scan/new" element={<ScanNew />} />
              <Route path="/scan/:id" element={<ScanDashboard />} />
              <Route path="/s/:id" element={<ScanDashboard />} />
              <Route path="/listing/:id" element={<ListingDetail />} />
              <Route path="/account" element={<Account />} />
              <Route path="/marche" element={<Marche />} />
              <Route path="/marche/:brandSlug/:modelSlug" element={<MarcheModel />} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AppShell>
        </BrowserRouter>
        </I18nProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}
